import { render, staticRenderFns } from "./publish-publish-button.vue?vue&type=template&id=064adcfc"
import script from "./publish-publish-button.vue?vue&type=script&lang=js"
export * from "./publish-publish-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports